import { render } from "./digitalAbout.vue?vue&type=template&id=0ef79e26&scoped=true"
import script from "./digitalAbout.vue?vue&type=script&lang=js"
export * from "./digitalAbout.vue?vue&type=script&lang=js"

import "./digitalAbout.vue?vue&type=style&index=0&id=0ef79e26&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef79e26"]])

export default __exports__